import React, { type ReactElement } from 'react';
import { Flex, useScreenSize } from '@banhala/ui-kit';

export const FloatingButtonsContainer: React.FC<{
  children: ReactElement;
}> = props => {
  const { width: screenWidth } = useScreenSize();
  return (
    <Flex.Center position={'relative'}>
      <Flex width={screenWidth}>{props.children}</Flex>
    </Flex.Center>
  );
};
